import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["VueOrderingController"], {
    multiple: $props.multiOrderable,
    value: $props.ordering,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:ordering', $event)))
  }, {
    default: _withCtx((controller) => [
      _createVNode($setup["VueTable"], _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _createSlots({ _: 2 }, [
        _renderList($setup.slotKeys, (key) => {
          return {
            name: key,
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))
            ])
          }
        }),
        ($props.orderableFields && $props.orderableFields.length)
          ? {
              name: "head-cell",
              fn: _withCtx((scope) => [
                ($props.orderableFields.includes(scope.field.key))
                  ? (_openBlock(), _createBlock($setup["Ordering"], {
                      key: 0,
                      field: scope.field,
                      controller: controller
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "head-cell", _normalizeProps(_guardReactiveProps(scope)), () => [
                          _createTextVNode(_toDisplayString(scope.field.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["field", "controller"]))
                  : _renderSlot(_ctx.$slots, "head-cell", _normalizeProps(_mergeProps({ key: 1 }, scope)), () => [
                      _createTextVNode(_toDisplayString(scope.field.label), 1)
                    ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1040)
    ]),
    _: 3
  }, 8, ["multiple", "value"]))
}